export const TEN_MINUTES = 1000 * 60 * 10;

export const DEBOUNCE_TIMER = 500;

export const PRICING_ROUTE = "https://www.11sight.com/pricing";

export const PIXEL_TRACKER = "https://ct.capterra.com/capterra_tracker.gif?vid=2154034&vkey=0c409896fbde01b622062e1183abfc8e";

export const CNAME_HYPERLINK = "https://help.11sight.com/home/Organization-Settings.1704095.html#OrganizationSettings-CNAME";